const daysWeekEnum = {
  oneTime: {
    value: 0,
    title: "Единоразово",
    titleFull: "Единоразово",
  },

  MON: {
    value: 1,
    title: "Пн",
    titleFull: "Понедельник",
  },
  TUE: {
    value: 2,
    title: "Вт",
    titleFull: "Вторник",
  },
  WED: {
    value: 4,
    title: "Ср",
    titleFull: "Среда",
  },
  THU: {
    value: 8,
    title: "Чт",
    titleFull: "Четверг",
  },
  FRI: {
    value: 16,
    title: "Пт",
    titleFull: "Пятница",
  },
  SAT: {
    value: 32,
    title: "Сб",
    titleFull: "Суббота",
  },
  SUN: {
    value: 64,
    title: "Вс",
    titleFull: "Воскресение",
  },
};

export const getDays = () => {
  return daysWeekEnum;
};

export const getDaysWeekState = (days) => {
  if (!days || days === 0)
    return {
      MON: false,
      TUE: false,
      WED: false,
      THU: false,
      FRI: false,
      SAT: false,
      SUN: false,
    };

  return {
    MON: (days & daysWeekEnum.MON.value) !== 0,
    TUE: (days & daysWeekEnum.TUE.value) !== 0,
    WED: (days & daysWeekEnum.WED.value) !== 0,
    THU: (days & daysWeekEnum.THU.value) !== 0,
    FRI: (days & daysWeekEnum.FRI.value) !== 0,
    SAT: (days & daysWeekEnum.SAT.value) !== 0,
    SUN: (days & daysWeekEnum.SUN.value) !== 0,
  };
};

export const getDaysWeekString = (days) => {
  const daysWeekState = getDaysWeekState(days);

  if (!days || days === 0) return "Единоразово";

  return `
  ${daysWeekState.MON ? daysWeekEnum.MON.title : ""}
  ${daysWeekState.TUE ? daysWeekEnum.TUE.title : ""}  
  ${daysWeekState.WED ? daysWeekEnum.WED.title : ""} 
  ${daysWeekState.THU ? daysWeekEnum.THU.title : ""} 
  ${daysWeekState.FRI ? daysWeekEnum.FRI.title : ""} 
  ${daysWeekState.SAT ? daysWeekEnum.SAT.title : ""} 
  ${daysWeekState.SUN ? daysWeekEnum.SUN.title : ""} 
  `;
};

export default daysWeekEnum;
